import React from 'react';
import { Paper, Typography, Grid, Avatar, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Buyer } from 'src/app/models/business/Buyer';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  label: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  value: {
    color: theme.palette.text.secondary,
  }
}));

type BuyerWithMetadata = Omit<
  Buyer,
  'buyer_id' | 'password' | 'created_at' | 'last_login' | 'company'
> & {
  date_of_birth?: string;
  metadata?: {
    cuil?: string;
  };
};

interface BuyerInfoCardProps {
  buyer: BuyerWithMetadata;
}

export const BuyerInfoCard: React.FC<BuyerInfoCardProps> = ({ buyer }) => {
  const classes = useStyles();
  if (!buyer) {
    return (
      <Paper className={classes.card}>
        <Typography variant="h6" gutterBottom>
          Información del Comprador
        </Typography>
        <Typography>No hay información disponible.</Typography>
      </Paper>
    );
  }

  return (
    <Paper className={classes.card}>
      <Typography variant="h6" gutterBottom>
        Información del Comprador
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.label}>Nombre y Apellido:</Typography>
          <Typography className={classes.value}>{`${buyer.name} ${buyer.lastname}`}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.label}>Email:</Typography>
          <Typography className={classes.value}>{buyer.email}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.label}>DNI:</Typography>
          <Typography className={classes.value}>
            {`${buyer.document_type} ${buyer.document_number}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.label}>CUIL:</Typography>
          <Typography className={classes.value}>{buyer.metadata?.cuil || '-'}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.label}>Fecha de nacimiento:</Typography>
          <Typography className={classes.value}>
            {buyer.date_of_birth ? new Date(buyer.date_of_birth).toLocaleDateString() : '-'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.label}>Teléfono:</Typography>
          <Typography className={classes.value}>{buyer.phone_number}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};
